"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INVERTED = void 0;
var INVERTED = ['ja-jp', 'ko-kr', 'zh-cn', 'zh-hk', 'zh-tw'];
exports.INVERTED = INVERTED;